import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../api';
import './Auth.css';

export default function Register() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', email: '', password: '', phone: '', genre: '', bio: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/artist-auth/register', form);
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Gagal mendaftar. Coba lagi.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="auth-page">
        <div className="auth-box">
          <h1 className="auth-logo">
          <img src="/logo.png" alt="Saskara Record" className="auth-logo-img" />
          SASKARA<span>RECORD</span>
        </h1>
          <div className="auth-success">
            <h2>Pendaftaran Berhasil!</h2>
            <p>Akun kamu sedang menunggu persetujuan admin. Kamu akan bisa login setelah disetujui — proses biasanya memakan waktu 1-2 hari kerja.</p>
            <Link to="/login" className="auth-link-btn">Kembali ke Login</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-box">
        <h1 className="auth-logo">
          <img src="/logo.png" alt="Saskara Record" className="auth-logo-img" />
          SASKARA<span>RECORD</span>
        </h1>
        <p className="auth-subtitle">Portal Artis — Daftar Sekarang</p>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Nama Artis / Panggung"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            required
          />
          <input
            type="email"
            placeholder="Email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            required
            minLength={6}
          />
          <input
            type="tel"
            placeholder="Nomor HP (opsional)"
            value={form.phone}
            onChange={(e) => setForm({ ...form, phone: e.target.value })}
          />
          <input
            type="text"
            placeholder="Genre (contoh: Dangdut, Pop)"
            value={form.genre}
            onChange={(e) => setForm({ ...form, genre: e.target.value })}
          />
          <textarea
            placeholder="Bio singkat (opsional)"
            rows={3}
            value={form.bio}
            onChange={(e) => setForm({ ...form, bio: e.target.value })}
          />
          <button type="submit" disabled={loading}>
            {loading ? 'Mendaftar...' : 'Daftar'}
          </button>
        </form>

        <p className="auth-footer-link">
          Sudah punya akun? <Link to="/login">Login di sini</Link>
        </p>
      </div>
    </div>
  );
}
